import React, { Component } from 'react'
import './BannerEnvIndicator.css'

class BannerEnvIndicator extends Component {
    render() {
        return (
            <>
                {process.env.REACT_APP_ACTIVATE_BANNER === 'true' && (
                    <div className="BannerEnvIndicator">
                        {process.env.REACT_APP_BANNER_CONTENT}
                    </div>
                )}
            </>
        )
    }
}

export default BannerEnvIndicator
